"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeMenuItemStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeMenuItemStyles = function makeMenuItemStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          color: tokens.colors["text-on-background"].color,
          minHeight: "auto",
          paddingTop: primitives.spacings["2"],
          paddingBottom: primitives.spacings["2"],
          position: "relative",
          whiteSpace: "normal",
          marginLeft: ".125rem",
          marginRight: ".125rem",
          paddingLeft: primitives.spacings["3"]
        }, tokens.typography["body-copy-medium-compact"]), {}, {
          "& .DhigSelect--checkedIcon": {
            position: "absolute",
            right: primitives.spacings["2"]
          },
          "& .DhigSelect--option": {
            marginRight: primitives.spacings["6"],
            width: "100%"
          }
        }, tokens.transitions["enter"]), {}, {
          "&:hover": _objectSpread({
            backgroundColor: tokens.colors["hover-fill-subtle"].rgb
          }, tokens.transitions["state-blur"]),
          "&:focus, &:focus-visible": {
            boxShadow: tokens.effects["focus-ring-thin"].boxShadow
          },
          "&.Mui-selected": {
            backgroundColor: tokens.colors["activated-fill-subtle"].rgb,
            "&:hover": {
              backgroundColor: tokens.colors["activated-hover-fill-subtle"].rgb
            }
          },
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["5"]),
          border: "2px solid transparent"
        }, tokens.transitions["state-blur"]), {}, {
          "&:hover, &:active, &:focus-visible": _objectSpread({}, tokens.transitions["state-activate"]),
          "&:active": {
            backgroundColor: tokens.colors["activated-fill-subtle"].rgb,
            border: "2px solid transparent"
          },
          "&.DhigSplitButton--menuItem--focused": {
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: tokens.colors["hover-fill-subtle"].rgb
            },
            "&:active": {
              backgroundColor: tokens.colors["pressed-fill-subtle"].rgb
            }
          },
          '& [class*="MuiSvgIcon-root"]': {
            paddingRight: primitives.spacings["2"]
          },
          "& .DhigSplitButton--icon--checkmark": {
            paddingLeft: primitives.spacings["3"],
            paddingRight: primitives.spacings["0"],
            marginLeft: "auto",
            width: primitives.spacings["4"]
          },
          "& .MuiTypography-root": {
            color: tokens.colors["ink-on-background"].rgb
          }
        })
      }
    }
  };
};

exports.makeMenuItemStyles = makeMenuItemStyles;